import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MessageService } from './../../service/message.service';
import { MessageType } from '../../model/show-message.event';
import { LanguageService, TranslationParameters } from '../../service/language.service';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageBoxComponent implements OnInit, OnDestroy {
  constructor(
    private readonly service: MessageService,
    private readonly languageService: LanguageService
  ) {}

  private subscription: Subscription;

  private setByType(type: MessageType) {
    switch (type) {
      case MessageType.Error:
        this.header = 'ERROR.HEADER';
        setTimeout(() => this.close(), 10000);
        break;
      case MessageType.Information:
        setTimeout(() => this.close(), 7000);
        break;
      case MessageType.Success:
        this.header = 'SUCCESS.HEADER';
        setTimeout(() => this.close(), 3000);
        break;
      case MessageType.Warning:
        this.header = 'WARNING.HEADER';
        setTimeout(() => this.close(), 7000);
        break;
    }
  }

  private show(type: MessageType, message: string, parameters?: TranslationParameters) {
    this.display = true;
    this.currentStyle = {
      show: this.display,
      error: type === MessageType.Error,
      success: type === MessageType.Success,
      warning: type === MessageType.Warning,
    };
    this.setByType(type);
    this.message = parameters ? this.languageService.getText(message, parameters) : message;
    this.parameters = parameters;
  }

  currentStyle: any;
  display: boolean;
  header: string;
  message: string;
  parameters: TranslationParameters;
  close() {
    this.display = false;
    this.currentStyle.show = false;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription = this.service.showMessage$.subscribe(e => this.show(e.type, e.message, e.parameters));
  }
}
